





























































































































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import { qrcodeAPI, orderQuery, skuList } from './types/api'
import PayModal from './PayModal.vue'
import PayAgreement from './PayAgreement.vue'
import { throttle, debounce } from 'throttle-debounce'
import { getCookie } from '@/utils/urlUtils'

let pageTimer: any = {}
let z = 0
@Component({
  components: { PayModal, PayAgreement },
  directives: {
    throttle: {
      bind(el) {
        // el.addEventListener('click', throttle(2000,))
      }
    }
  }
})
export default class PayQrcode extends Vue {
  @Prop() data!: any
  // data
  public cards = []
  public currentIdx = 0
  public currentOrder = ''
  public currentQrcode = require('./../../../assets/images/qrcode.png')
  public agreementStatus = false
  public qrcodeStatus = false
  public success = false
  public loading = false
  public resData: any = null
  // computed
  public get currentItem() {
    if (this.cards.length > 0) {
      return this.cards[this.currentIdx]
    }
    return {
      discount_price: 0,
      price: 0,
      sku_name: '',
      valid_days: 0,
      available: false,
      coupon_num: 0,
      platform_sku_id: '',
      icon_url: ''
    }
  }
  public get user() {
    return this.$store.state.user
  }
  public get userInfo() {
    return this.$store.state.user_info
  }
  public get uid() {
    return getCookie('uid')
  }
  public get userName() {
    let regMobile = /^0?1[3|4|5|8][0-9]\d{8}$/
    if (!this.user) {
      return ''
    }
    // if (regMobile.test(this.user.name)) {
    //   return this.user.name.replace(/\d{4}(?=[\d\D]{4}$)/, () => '****')
    // } else {
    //   return this.user.name
    // }
    return this.user.name
  }
  public get modalData() {
    return this.$store.state.payModal
  }
  // destroyed
  public destroyed() {
    for (let each in pageTimer) {
      clearInterval(pageTimer[each])
    }
    pageTimer = {}
  }
  @Watch('modalData', { deep: true })
  onModalChange(data) {
    // console.log(data)
    this.qrcodeStatus = data.state
  }
  @Watch('data', { immediate: true })
  onDataChange(val) {
    this.cards = val
  }
  @Watch('cards', { deep: true })
  onCardsChange(val) {
    if (val && val.length > 0) {
      this.currentIdx = val.findIndex((itm, index) => {
        return itm.available
      })
    }
  }
  @Watch('user', { deep: true })
  onUserChange(val, old) {
    if (this.qrcodeStatus && val && !old) {
      // this.getSkuList()
      this.currentIdx = this.cards.findIndex((itm: any, index) => {
        return itm.available
      })
      this.getQrcode(this.currentIdx)
    }
  }
  @Watch('qrcodeStatus')
  onVisibleChange(val) {
    if (!val) {
      this.reset()
    } else {
      if (!this.user) {
        return
      }
      this.getQrcode(this.currentIdx)
    }
  }
  // mounted
  public mounted() {
    // this.qrcodeStatus = true
    // this.getSkuList()
  }
  // methods
  public async getSkuList() {
    let { data } = await skuList({
      sku_type: 'membership'
    })
    // console.log(data)
    this.cards = data
  }
  public reset() {
    this.clearTimers()
    pageTimer = {}
    this.currentOrder = ''
    this.currentIdx = this.cards.findIndex((itm: any) => {
      return itm.available
    })
  }
  public back() {
    this.success = false
    this.reset()
    this.getQrcode(this.currentIdx)
  }
  public goDetail() {
    location.href = '/search/personal/mine'
  }
  public clickLogin() {
    // this.qrcodeStatus = false
    this.$store.commit('SET_LOGINMODAL', true)
  }
  public clickRegister() {
    // this.qrcodeStatus = false
    this.$store.commit('SET_LOGINMODAL', [true, 2])
  }
  public agreementCancel() {
    this.agreementStatus = false
  }
  public qrcodeCancel() {
    this.qrcodeStatus = false
    this.$store.commit('SET_PAYMODAL', {
      state: false,
      index: 0
    })
  }
  public readAgreement() {
    this.agreementStatus = !this.agreementStatus
  }
  // 选择会员包
  public chooseOne(item: any, idx: number) {
    if (!this.user) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    if (!item.available) {
      return
    }
    this.currentIdx = idx
    this.clearTimers()
    this.getQrcode(idx)
  }
  // 获取二维码
  public async getQrcode(idx: number) {
    let that = this
    this.loading = true
    let { data } = await qrcodeAPI({
      bizKey: 'PC',
      appKey: 'ContentSearch',
      payMode: 'WX_QRCODE',
      payPrice: this.currentItem.discount_price,
      //callback:
      productId: this.currentItem.platform_sku_id,
      userId: this.uid,
      callback: 'https://content.17zuoye.com/search/api/pay/order/callback'
    })
    // console.log(data)
    this.loading = false
    this.currentOrder = data.orderId
    this.currentQrcode = data.qrcode
    // 设置定时器
    pageTimer[`timer${z}`] = setInterval(function() {
      // console.log(`timer${z}`)
      // console.log(pageTimer)
      that.queryStatus()
    }, 2000)
    // 设置超时时间
    pageTimer.clearTimer = setTimeout(function() {
      that.clearTimers()
    }, 600000)
    z++
  }
  // 订单状态查询
  public async queryStatus() {
    let data = await orderQuery({
      orderId: this.currentOrder,
      skuId: this.currentItem.platform_sku_id
    })
    let temp = {}
    if (data.success) {
      this.clearTimers()
      this.resData = data.data
      temp = JSON.parse(data.data.attrsJson)
      this.resData = { ...this.resData, ...temp }
      // console.log(temp)
      // console.log(this.resData)
      this.success = true
      this.getSkuList()
    }
  }
  // 清除定时器
  public clearTimers() {
    for (let each in pageTimer) {
      clearInterval(pageTimer[each])
      pageTimer[each] = null
    }
  }
}
